import axios from 'axios'

class GeocodeAPI {
  getGeocode = async (query: string) => {
    return axios.get(`api/geocode/json${query}`)
  }
}

export const geocodeAPI = new GeocodeAPI()
